import React from "react";

const RoleDropdown = ({ name, value, onChange }) => {
  return (
    <select name={name} value={value} onChange={onChange} className="form-select">
      <option value="">Select Role</option>
      <option value="Assistant">MA Assistant</option>
      <option value="BillingAssistant">Billing Assistant</option>
      <option value="ScpAssistant">Specialized Care Program Assistant</option>
      <option value="CommAssistant">Communication Assistant</option>
      <option value="FaxAssistant">Fax Assistant</option>
    </select>
  );
};

export default RoleDropdown;